import { render, staticRenderFns } from "./TeachersRow.vue?vue&type=template&id=1baf0d6c&scoped=true&"
import script from "./TeachersRow.vue?vue&type=script&lang=ts&"
export * from "./TeachersRow.vue?vue&type=script&lang=ts&"
import style0 from "./TeachersRow.vue?vue&type=style&index=0&id=1baf0d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf0d6c",
  null
  
)

export default component.exports